import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { BillingView } from '@/models/billing'

import PlanCards from './PlanCards.vue'
import InfoFAQ from '@/app/components/billing/InfoFAQ.vue'
import BillingCoupon from '@/app/components/billing/BillingCoupon.vue'
import Benefits from './Benefits.vue'
import Features from './Features.vue'
import Bestselling from './Bestselling.vue'
import UserReview from './UserReview.vue'
import BillingNotifications from './BillingNotifications.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingData',
  props: {
    billing: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.billing.showDiscountBanner)
      ? (_openBlock(), _createBlock(BillingCoupon, {
          key: 0,
          billing: __props.billing,
          class: "billing-data__coupon billing-notifications__prompt"
        }, null, 8, ["billing"]))
      : _createCommentVNode("", true),
    _createVNode(BillingNotifications, {
      class: "billing-data__notification",
      billing: __props.billing
    }, null, 8, ["billing"]),
    _createVNode(PlanCards, { billing: __props.billing }, null, 8, ["billing"]),
    _createVNode(Features),
    _createVNode(UserReview),
    _createVNode(Benefits, { class: "billing-data__benefits" }),
    _createVNode(Bestselling),
    _createVNode(PlanCards, {
      billing: __props.billing,
      "is-secondary": ""
    }, null, 8, ["billing"]),
    _createVNode(InfoFAQ, {
      id: "faq",
      class: "billing-data__faq"
    })
  ], 64))
}
}

})